<div class="wrapper" [style.background]="background" (click)="onShowDetails()">
  <div class="whiteOverlay">
    @if (musicCollection) {
      <div class="titleContainer">
        {{musicCollection.title}}
        <!--<tun-scrollable-text class="title" [text]="musicCollection.title"></tun-scrollable-text>-->
      </div>
    }
  </div>
</div>
